module.exports = __webpack_public_path__ + "img/banner-01.88ac5c96.jpg";